var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25L31.7581 31.9436C32.1766 32.2574 32.7662 32.1957 33.1107 31.8021L50 12.5",
    stroke: "#F4F5F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30C52.5 34.7012 51.0274 39.2844 48.2891 43.1057C45.5507 46.9271 41.6841 49.7948 37.2324 51.3059C32.7807 52.8171 27.9674 52.8959 23.4686 51.5312C18.9698 50.1665 15.0115 47.4269 12.1496 43.6971C9.28762 39.9674 7.66587 35.4349 7.51205 30.7362C7.35823 26.0375 8.68007 21.4086 11.2919 17.4997C13.9038 13.5907 17.6745 10.5981 22.0744 8.94212C26.4743 7.28611 31.2824 7.0499 35.8234 8.26667",
    stroke: "#F4F5F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.19ada09c73173e789a827c3306455d6f.svg";
export { ForwardRef as ReactComponent };